import { StateUtils } from '@spartacus/core';
import { TrackingDeliveryApi, TrackingPickup } from '@tracking/const';

export const TRACKING_FEATURE = 'tracking';
export const TRACKING_DELIVERY = '[Tracking] Tracking Delivery';
export const TRACKING_PICKUP = '[Tracking] Tracking Pickup';

export interface StateWithTracking {
  [TRACKING_FEATURE]: TrackingState;
}

export interface TrackingState {
  trackingDelivery: StateUtils.EntityLoaderState<TrackingDeliveryApi>;
  trackingPickup: StateUtils.EntityLoaderState<TrackingPickup>;
}
